import { render, staticRenderFns } from "./DynamicFormRender.vue?vue&type=template&id=48558e90"
import script from "./DynamicFormRender.vue?vue&type=script&lang=js"
export * from "./DynamicFormRender.vue?vue&type=script&lang=js"
import style0 from "./DynamicFormRender.vue?vue&type=style&index=0&id=48558e90&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports